import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CustomFieldTypeView } from '@api-proxies';
import { CustomFieldTypeService } from '@http/clients/custom-field-type.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-custom-field-type-editor',
    templateUrl: './custom-field-type-editor.component.html',
    styleUrls: ['./custom-field-type-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class CustomFieldTypeEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    source: CustomFieldTypeView[] = [];
    selectedType?: CustomFieldTypeView;

    constructor(private customFieldTypeService: CustomFieldTypeService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.source = this.additionalInfo?.source ?? [];

        // Only make HTTP call if no source data is provided
        if (!this.source?.length) {
            this.source = await this.customFieldTypeService.getAll();
        }

        if (this.bindingProperty !== null) {
            this.selectedType = this.source.find((x) => x.id === this.bindingProperty);
        }
    }

    onSelectType() {
        this.bindingProperty = this.selectedType?.id ?? null;
        this.valueChange.emit();
    }
}
